import { render, staticRenderFns } from "./timeChild.vue?vue&type=template&id=fe765b70&scoped=true"
import script from "./timeChild.vue?vue&type=script&lang=js"
export * from "./timeChild.vue?vue&type=script&lang=js"
import style0 from "./timeChild.vue?vue&type=style&index=0&id=fe765b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe765b70",
  null
  
)

export default component.exports